<app-search></app-search>
<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      <h1 class="title">Lista de Planes de Vida</h1>
    </div>
    <br />
    <div class="card-header">
      <button id="" class="primary-button" appPermision="/lifeplan+c" (click)="createLifePlan()">
        <span class="button-content"> <mat-icon>add_circle</mat-icon> Agregar nuevo </span>
      </button>
    </div>
    <br />
    <div class="table-scroll-wrapper">
      <section class="table-container mat-elevation-z1" tabindex="0">
        <div class="table-adjustable">
          <table
            mat-table
            [dataSource]="
              (asyncLifeplans | async) ?? []
                | paginate
                  : {
                      id: 'server',
                      itemsPerPage: limit,
                      currentPage: page,
                      totalItems: total,
                    }
            "
          >
            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let lifeplan">
                <div class="action-buttons">
                  <a
                    title="Editar"
                    class="icon-button"
                    appPermision="/lifeplan+u"
                    (click)="updateLifePlan(lifeplan)"
                  >
                    <span class="material-symbols-outlined"><mat-icon>edit</mat-icon></span>
                  </a>
                  <a appOnlysuperuser="/lifeplan" (click)="eliminate(lifeplan)" class="icon-button">
                    <span class="material-symbols-outlined"><mat-icon>delete</mat-icon></span>
                  </a>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let lifeplan">
                {{ lifeplan.id }}
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Nombre</th>
              <td mat-cell *matCellDef="let lifeplan">
                {{ lifeplan.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="code">
              <th mat-header-cell *matHeaderCellDef>Código</th>
              <td mat-cell *matCellDef="let lifeplan">
                {{ lifeplan.code }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: showColumns" class="highlight-row"></tr>
          </table>
        </div>
      </section>
    </div>
    <pagination-controls
      (pageChange)="fetchLifePlan($event)"
      previousLabel="Anterior"
      nextLabel="Siguiente"
      id="server"
    ></pagination-controls>
  </div>
</div>
